module.exports = __webpack_public_path__ + "static/img/fnac-unibet-notre-classement-des-enseignes-de-loisirs-et-de-la-culture-1258666.555525f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fnac-unibet-notre-classement-des-enseignes-de-loisirs-et-de-la-culture-1258666.jpg
// module id = uo7H
// module chunks = 1